import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: BoxIcon;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'right',
  fullWidth = false,
  children,
  className = '',
  ...props
}) => {
  const baseStyles = 'relative inline-flex items-center justify-center font-medium transition-all duration-300 rounded-full overflow-hidden group';
  const variants = {
    primary: 'bg-white text-lab-black hover:bg-gray-200 shadow-[0_0_20px_rgba(255,255,255,0.1)] hover:shadow-[0_0_30px_rgba(255,255,255,0.2)]',
    secondary: 'bg-lab-violet text-white hover:bg-lab-violetLight shadow-[0_0_20px_rgba(109,40,217,0.2)] hover:shadow-[0_0_30px_rgba(139,92,246,0.4)]',
    outline: 'border border-white/10 text-white hover:bg-white/5 hover:border-white/20',
    ghost: 'text-lab-muted hover:text-white hover:bg-white/5'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2 gap-2',
    md: 'text-sm px-6 py-3 gap-2',
    lg: 'text-base px-8 py-4 gap-3'
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-17">
      {/* Subtle gradient overlay for primary/secondary */}
      {(variant === 'primary' || variant === 'secondary') && <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out" data-id="element-18" />}

      {Icon && iconPosition === 'left' && <Icon size={size === 'sm' ? 16 : size === 'lg' ? 20 : 18} className="relative z-10" data-id="element-19" />}
      <span className="relative z-10 font-display tracking-wide" data-id="element-20">
        {children}
      </span>
      {Icon && iconPosition === 'right' && <Icon size={size === 'sm' ? 16 : size === 'lg' ? 20 : 18} className="relative z-10" data-id="element-21" />}
    </motion.button>;
};